import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2f22df87"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "group" }
const _hoisted_2 = { class: "content-wrapper" }
const _hoisted_3 = { class: "group-wrapper" }
const _hoisted_4 = { class: "info-wrapper" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Eingeladen", -1))
const _hoisted_6 = { class: "info-wrapper" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Zuletzt aktualisiert", -1))
const _hoisted_8 = { class: "delete-button-wrapper" }
const _hoisted_9 = { class: "tables-wrapper" }
const _hoisted_10 = { class: "table-header" }
const _hoisted_11 = { class: "title-button-wrapper" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Mitglieder", -1))
const _hoisted_13 = { class: "table-header" }
const _hoisted_14 = { class: "title-button-wrapper" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Berechtigungen", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_md_tabs = _resolveComponent("md-tabs")!
  const _component_group_card_loader = _resolveComponent("group-card-loader")!
  const _component_md_button = _resolveComponent("md-button")!
  const _component_md_card = _resolveComponent("md-card")!
  const _component_md_table_column = _resolveComponent("md-table-column")!
  const _component_md_table = _resolveComponent("md-table")!
  const _component_empty_hint = _resolveComponent("empty-hint")!
  const _component_group_delete_modal = _resolveComponent("group-delete-modal")!
  const _component_user_remove_from_group_modal = _resolveComponent("user-remove-from-group-modal")!
  const _component_update_permissions_modal = _resolveComponent("update-permissions-modal")!
  const _component_group_add_member_modal = _resolveComponent("group-add-member-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_md_tabs, {
      title: "Gruppe",
      "title-only": ""
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_md_card, {
          variant: "filled",
          class: "group-card"
        }, {
          default: _withCtx(() => [
            (_ctx.group)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("h2", null, _toDisplayString(_ctx.group.name), 1),
                  _createElementVNode("div", _hoisted_4, [
                    _hoisted_5,
                    _createElementVNode("p", null, _toDisplayString(_ctx.formatedDateTime(new Date(_ctx.group.created))) + " Uhr", 1)
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    _hoisted_7,
                    _createElementVNode("p", null, _toDisplayString(_ctx.formatedDateTime(new Date(_ctx.group.updated))) + " Uhr", 1)
                  ])
                ], 64))
              : (_openBlock(), _createBlock(_component_group_card_loader, { key: 1 })),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_md_button, {
                variant: "filled",
                mode: "delete",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.deleteModal.open()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Gruppe löschen")
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createVNode(_component_md_button, {
                variant: "outlined",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addMemberModal.open()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Mitglied hinzufügen")
                ]),
                _: 1
              })
            ])
          ]),
          ((_ctx.members && _ctx.members.length > 0) || _ctx.isMembersLoading)
            ? (_openBlock(), _createBlock(_component_md_table, {
                key: 0,
                rows: _ctx.members,
                header: false,
                clickable: "",
                onClick: _ctx.redirectToUser,
                "skeleton-rows": 3,
                onButtonClick: _ctx.handleGroupsTableClick
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_md_table_column, {
                    title: "",
                    display: "image",
                    type: "avatar"
                  }),
                  _createVNode(_component_md_table_column, {
                    title: "Name",
                    display: "name"
                  }),
                  _createVNode(_component_md_table_column, {
                    title: "",
                    display: "remove",
                    type: "button"
                  })
                ]),
                _: 1
              }, 8, ["rows", "onClick", "onButtonClick"]))
            : (_openBlock(), _createBlock(_component_empty_hint, {
                key: 1,
                title: "Zu dieser Gruppen wurden noch keine Mitglieder hinzugefügt",
                variant: "inline"
              })),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _createVNode(_component_md_button, {
                variant: "outlined",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.updatePermissionsModal.open()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Berechtigungen verwalten")
                ]),
                _: 1
              })
            ])
          ]),
          ((_ctx.permissions && _ctx.permissions.length > 0) || !_ctx.group)
            ? (_openBlock(), _createBlock(_component_md_table, {
                key: 2,
                rows: _ctx.permissions,
                header: false,
                "skeleton-rows": 3
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_md_table_column, {
                    title: "Readable",
                    display: "readable"
                  })
                ]),
                _: 1
              }, 8, ["rows"]))
            : (_openBlock(), _createBlock(_component_empty_hint, {
                key: 3,
                title: "Dieser Gruppen wurden keine Berechtigungen zugewiesen",
                variant: "inline"
              }))
        ])
      ])
    ]),
    (_ctx.group)
      ? (_openBlock(), _createBlock(_component_group_delete_modal, {
          key: 0,
          ref: "deleteModal",
          group: _ctx.group,
          onSubmit: _ctx.deleteGroup
        }, null, 8, ["group", "onSubmit"]))
      : _createCommentVNode("", true),
    (_ctx.group)
      ? (_openBlock(), _createBlock(_component_user_remove_from_group_modal, {
          key: 1,
          ref: "removeMemberModal",
          onSubmit: _cache[3] || (_cache[3] = ($event: any) => (_ctx.loadMembers())),
          user: _ctx.targetMember,
          group: _ctx.group
        }, null, 8, ["user", "group"]))
      : _createCommentVNode("", true),
    _createVNode(_component_update_permissions_modal, {
      ref: "updatePermissionsModal",
      permissions: _ctx.rawPermissions,
      onSubmit: _ctx.setPermissions
    }, null, 8, ["permissions", "onSubmit"]),
    (_ctx.group)
      ? (_openBlock(), _createBlock(_component_group_add_member_modal, {
          key: 2,
          ref: "addMemberModal",
          group: _ctx.group,
          onSubmit: _cache[4] || (_cache[4] = ($event: any) => (_ctx.loadMembers()))
        }, null, 8, ["group"]))
      : _createCommentVNode("", true)
  ]))
}